export default __webpack_public_path__ + "static/media/badge.c30dc4ba.svg";